import React, { useState } from 'react';
import { IconButton, TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import useTranslation from 'Hooks/useTranslation';
import { SPANISH } from 'Constants/General';
import CloseIcon from '@mui/icons-material/Close';
import { TextFieldStyle, ContainerTextField } from './style';

export default function DateRange({ startDate, setStartDate, endDate, setEndDate, setIsLoading }) {
  const { t2, language } = useTranslation('Generic');
  const [firstDateDisable, setFirstDateDisable] = useState(false);
  const [secondDateDisable, setSecondDateDisable] = useState(true);
  const [openSecondDate, setOpenSecondDate] = useState(false);

  if (language === SPANISH) import('moment/locale/es');

  const handleFirstDateChange = newFirstDate => {
    setStartDate(newFirstDate);
    setSecondDateDisable(false);
    setFirstDateDisable(true);
    setOpenSecondDate(true);
  };

  const handleSecondDateChange = newEndDate => {
    setEndDate(newEndDate);
    setOpenSecondDate(false);
    setFirstDateDisable(false);
    setSecondDateDisable(true);
    setIsLoading(true);
  };

  const handleDateClear = () => {
    setStartDate(null);
    setEndDate(null);
    setSecondDateDisable(true);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div style={{ display: 'flex' }}>
        <DatePicker
          label={t2('Start')}
          value={startDate}
          disabled={firstDateDisable}
          onChange={newStartDate => {
            handleFirstDateChange(newStartDate);
          }}
          renderInput={params => (
            <ContainerTextField>
              <TextField style={TextFieldStyle} {...params} color="MexlogGreen" />
            </ContainerTextField>
          )}
        />
        <DatePicker
          label={t2('End')}
          value={endDate}
          open={openSecondDate}
          disabled={secondDateDisable}
          disableHighlightToday
          minDate={startDate}
          onChange={newEndDate => handleSecondDateChange(newEndDate)}
          renderInput={props => (
            <ContainerTextField>
              <TextField style={TextFieldStyle} {...props} color="MexlogGreen" />
            </ContainerTextField>
          )}
        />
        {endDate !== null ? (
          <IconButton onClick={handleDateClear}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </div>
    </LocalizationProvider>
  );
}
